export const fa = {
    LEFT: 'سمت چپ: حرکت به روز قبل ،',
    RIGHT: 'راست: حرکت به روز بعد.',
    DOWN: 'پایین: حرکت به سطر بعدی. | | : حرکت به ردیف قبلی.',
    UP: 'PgUp: حرکت به ماه قبل است.',
    PGUP: 'PgDown: انتقال به ماه بعد.',
    PGDOWN: 'صفحه اصلی: حرکت به سال قبل است.',
    HOME: 'End: انتقال به سال بعد.',
    END: 'Esc/امروز/بستن: بستن تقویم. | صفحه کلید| دستورالعمل'
};
